import React from 'react'
import './OutlinedBtnPrimary.css'
import { Button } from 'primereact/button'

export default function OutlinedBtnPrimary({ ...rest }) {
  // Render
  return <Button {...rest} className="OutlinedBtnPrimary p-button-outlined" />
}
